import API from '../Utils/API';

export const getLayout = (url) => (dispatch) => {
  dispatch({ type: 'GET_LAYOUT_REQUEST' });
  API.get(url)
    .then((response) => {
      dispatch({ type: 'GET_LAYOUT_SUCCESS', payload: response.data });
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_LAYOUT_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const createLayout =
  (data, successCreateLayout, failureCreateLayout) => (dispatch) => {
    dispatch({ type: 'CREATE_LAYOUT_REQUEST' });
    API.post('api/organization_layouts', data)
      .then((response) => {
        dispatch({
          type: 'CREATE_LAYOUT_SUCCESS',
          payload: response.data,
        });
        successCreateLayout && successCreateLayout();
      })
      .catch((error) => {
        dispatch({
          type: 'CREATE_LAYOUT_FAILURE',
          payload: error.response.data,
        });
        failureCreateLayout && failureCreateLayout(error.response.data);
      });
  };

export const deleteLayout = (layoutId, successDeleteCallback) => (dispatch) => {
  dispatch({ type: 'DELETE_LAYOUT_REQUEST' });
  API.delete(`/api/organization_layouts/${layoutId}`)
    .then((response) => {
      dispatch({ type: 'DELETE_LAYOUT_SUCCESS', payload: response.data });
      successDeleteCallback && successDeleteCallback();
    })
    .catch((error) => {
      dispatch({
        type: 'DELETE_LAYOUT_FAILURE',
        payload: error.response.data,
      });
    });
};

export const updateLayout =
  (data, successUpdateCallBack, failureUpdateCallBack) => (dispatch) => {
    dispatch({ type: 'UPDATE_LAYOUT_REQUEST' });
    API.put(`api/organization_layouts/${data.id}`, data)
      .then((response) => {
        dispatch({ type: 'UPDATE_LAYOUT_SUCCESS', payload: response.data });
        successUpdateCallBack && successUpdateCallBack();
      })
      .catch((error) => {
        dispatch({
          type: 'UPDATE_LAYOUT_FAILURE',
          payload: error.response.data,
        });
        failureUpdateCallBack && failureUpdateCallBack(error.response.data);
      });
  };
